module.exports = __webpack_public_path__ + "img/2c5472594db4461888357ce83081a4fd.b2202761.png";